// Number of days after an order is declined during which it can still be reverted to approved.
export const REVERT_WINDOW_DAYS = 30;

/**
 * Returns true when the order was declined within the revert window (REVERT_WINDOW_DAYS days).
 * Shared by KitsilanoHeldOrders.vue and its test so the rule has a single source of truth.
 *
 * @param {{updated_at: (string|null|undefined)}} order
 * @returns {boolean}
 */
export function isRevertible(order) {
  if (!order.updated_at) {
    return false;
  }
  const declinedAt = new Date(order.updated_at);
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - REVERT_WINDOW_DAYS);
  return declinedAt >= cutoff;
}
